module.exports = __webpack_public_path__ + "img/vmc_aniv12_24Aug2021.50624d17.jpg";